// app/javascript/controllers/accordion_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "content"];

  toggle(event) {
    const index = this.itemTargets.indexOf(event.currentTarget);
    const content = this.contentTargets[index];
    const isExpanded = content.classList.toggle("hidden");

    // Mettre à jour les attributs ARIA
    event.currentTarget.setAttribute("aria-expanded", !isExpanded);
    content.setAttribute("aria-hidden", isExpanded);
  }
}